export const aboutData = {
  title: "Who I am",
  description1:
    "My name's Annamalai. I'm a web designer and developer based in Chennai, INDIA.",
  description2:
    "During the day I work as a developer at LUMEL and in the evening I utilize the time to built my own projects. I spent my leisure hours writing blogs and codes. Right now I'm upgrading myself as a full stack developer. I love to learn and explore new arenas.",
  image: 2,
};
